export const headerImage = require("../assets/news/home-font.png");
export const headerBottomImage = require("../assets/news/home-bottom-shape.png");
export const aboutCompanyImage = require("../assets/news/about.jpg");
export const chooseCompanyImage = require("../assets/news/choose-1.png");
export const trushCompanyImage = require("../assets/news/choose-2.png");
